'use client';

import { useEffect, useState } from 'react';
import { pwaManager } from '@/lib/pwa';

interface PWAProviderProps {
  children: React.ReactNode;
}

export function PWAProvider({ children }: PWAProviderProps) {
  const [isRegistered, setIsRegistered] = useState(false);

  useEffect(() => {
    // Register service worker on mount
    const registerServiceWorker = async () => {
      try {
        const registration = await pwaManager.registerServiceWorker('/sw.js');
        if (registration) {
          console.log('Service Worker registered successfully');
          setIsRegistered(true);
        }
      } catch (error) {
        console.error('Service Worker registration failed:', error);
      }
    };

    // Register service worker in production or when explicitly enabled
    if (process.env.NODE_ENV === 'production' || process.env.NEXT_PUBLIC_PWA_ENABLED === 'true') {
      registerServiceWorker();
    } else {
      console.log('Service Worker registration skipped in development. Set NEXT_PUBLIC_PWA_ENABLED=true to enable.');
    }
  }, []);

  return <>{children}</>;
}

export default PWAProvider;